import React from "react";
import { Globe, Package, User } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Combobox } from "./Combobox";
import { useApp } from "../context/AppContext";

export const InquiryFields = ({ form, setForm }) => {
  const { countries, t } = useApp();
  const set = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));
  const options = countries.map((c) => ({ value: c.name, label: c.name, flag: c.flag }));
  const input = (key, label, props = {}) => (
    <div className="min-w-0">
      <Label htmlFor={`inquiry-${key}`}>{t(`inquiry.${label}`)}{props.required && <span className="text-orange-600"> *</span>}</Label>
      <Input id={`inquiry-${key}`} data-testid={`inquiry-${key}-input`} value={form[key]} onChange={(e) => set(key, e.target.value)} className="mt-2 bg-white h-11" {...props} />
    </div>
  );
  return <div className="space-y-8">
    <section className="space-y-5">
      <h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><User className="w-5 h-5 text-orange-600" />{t("inquiry.contact")}</h2>
      <div className="grid sm:grid-cols-2 gap-5">
        {input("name", "name", { required: true, minLength: 2, maxLength: 120, autoComplete: "name" })}
        {input("phone", "phone", { required: true, type: "tel", maxLength: 30, autoComplete: "tel", placeholder: "+39 …" })}
      </div>
    </section>
    <section className="space-y-5 border-t border-black/10 pt-7">
      <h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><Globe className="w-5 h-5 text-orange-600" />{t("inquiry.route")}</h2>
      <div className="grid sm:grid-cols-2 gap-5">
        {[["senderCountry", "origin"], ["receiverCountry", "destination"]].map(([key, label]) => <div key={key} className="min-w-0">
          <Label htmlFor={`inquiry-${key}`}>{t(`inquiry.${label}`)} <span className="text-orange-600">*</span></Label>
          <div className="mt-2"><Combobox id={`inquiry-${key}`} testId={`inquiry-${label}-select`} options={options} value={form[key]} onChange={(v) => set(key, v)} placeholder={t("inquiry.selectCountry")} searchPlaceholder={t("inquiry.searchCountry")} emptyText={t("inquiry.noCountry")} /></div>
        </div>)}
      </div>
    </section>
    <section className="space-y-5 border-t border-black/10 pt-7">
      <h2 className="font-display font-semibold text-base md:text-lg flex items-center gap-2"><Package className="w-5 h-5 text-orange-600" />{t("inquiry.parcel")}</h2>
      <div className="grid sm:grid-cols-[2fr_1fr] gap-5">
        {input("contents", "contents", { maxLength: 500 })}
        {input("weight", "weight", { type: "number", min: "0.01", max: "100000", step: "0.01", inputMode: "decimal" })}
      </div>
      <div><Label htmlFor="inquiry-message">{t("inquiry.question")}</Label><Textarea id="inquiry-message" data-testid="inquiry-message-input" maxLength={2000} value={form.message} onChange={(e) => set("message", e.target.value)} className="mt-2 min-h-24 bg-white" /></div>
    </section>
  </div>;
};